export default __webpack_public_path__ + "5141a0d4dae1be15f0a1e9971ab9fd20.png";